const TABLET_MIN_SMALLEST_SIDE = 600

export function isTabletDevice(): boolean {
  if (typeof window === 'undefined') return false

  const userAgent = navigator.userAgent || ''
  const isIPad = /iPad/.test(userAgent)
    || (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1)

  if (isIPad) return true

  const smallestViewportSide = Math.min(window.innerWidth, window.innerHeight)
  const smallestScreenSide = Math.min(window.screen.width, window.screen.height)
  const smallestSide = Math.max(smallestViewportSide, smallestScreenSide)

  if (smallestSide >= TABLET_MIN_SMALLEST_SIDE) return true

  return /Android/i.test(userAgent) && !/Mobile/i.test(userAgent)
}
